"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ColonyName_1 = require("@/common/colonies/ColonyName");
const BuildBenefit_vue_1 = __importDefault(require("./BuildBenefit.vue"));
exports.default = (0, vue_1.defineComponent)({
    components: { BuildBenefit: BuildBenefit_vue_1.default },
    name: 'ColonyRow',
    props: {
        idx: {
            type: Number,
            required: true,
        },
        metadata: {
            type: Object,
            required: true,
        },
        player: {
            type: String,
            default: undefined,
        },
        marker: {
            type: Boolean,
        },
    },
    computed: {
        ColonyName() {
            return ColonyName_1.ColonyName;
        },
    },
});
